import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Dropdown } from 'semantic-ui-react';
import { useData } from '../context/DataContext';

const seasonOptions = [
  { key: '2026', text: 'Saison 2026/2027', value: '2026' },
  { key: '2025', text: 'Saison 2025/2026', value: '2025' },
  { key: '2024', text: 'Saison 2024/2025', value: '2024' },
  { key: '2023', text: 'Saison 2023/2024', value: '2023' },
];

const genderOptions = [
  { key: 'male', text: 'Homme', value: 'male' },
  { key: 'female', text: 'Femme', value: 'female' },
];

const Navbar = () => {
  const { season, setSeason, gender, setGender } = useData();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="premium-navbar">
      <div className="premium-navbar-inner">
        <NavLink to="/" className="premium-navbar-brand" onClick={closeMenu}>
          <img
            src={require('../assets/img/logo_front.png')}
            alt="French Ranking"
            className="premium-navbar-logo"
          />
        </NavLink>

        <button
          type="button"
          className="premium-navbar-toggle"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Ouvrir le menu"
        >
          ☰
        </button>

        <div className={`premium-navbar-links ${menuOpen ? 'open' : ''}`}>
          <NavLink to="/" end className={({ isActive }) => `premium-navlink ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Accueil
          </NavLink>
          <NavLink to="/recherche" className={({ isActive }) => `premium-navlink ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Recherche
          </NavLink>
          <NavLink to="/classement" className={({ isActive }) => `premium-navlink ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Classement général
          </NavLink>
          <NavLink to="/stats-categorie" className={({ isActive }) => `premium-navlink ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Stats par catégorie
          </NavLink>
          <NavLink to="/fiche-de-note" className={({ isActive }) => `premium-navlink ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Décode ma feuille de note
          </NavLink>
        </div>

        <div className="premium-navbar-filters">
          <Dropdown selection compact options={seasonOptions} value={season} onChange={(e, { value }) => setSeason(value)} className="premium-navbar-dropdown" />
          <Dropdown selection compact options={genderOptions} value={gender} onChange={(e, { value }) => setGender(value)} className="premium-navbar-dropdown" />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
